<!-- eslint-disable vue/valid-v-model -->
<template>
  <div class="feedback-container">
    <div class="content" ref="table">
      <div class="tools clearfix">
        <div class="left">
          <el-input
            v-model="searchInfo.orderNo"
            placeholder="输入订单编号"
            style="width: 210px; display: inline-block; margin-left: 10px"
          ></el-input>
          <el-input
            v-model="searchInfo.mobile"
            placeholder="输入用户手机号"
            style="width: 210px; display: inline-block; margin-left: 10px"
          ></el-input>
          <el-input
            v-model="searchInfo.frameNum"
            placeholder="输入车辆编号"
            style="width: 210px; display: inline-block; margin-left: 10px"
          ></el-input>
          <el-date-picker
            style="margin-left: 10px;"
            v-model="selectTime"
            type="datetimerange"
            range-separator="至"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <el-button type="primary" style="margin-left: 16px" @click="search"
            >搜索</el-button
          >
        </div>

        <div class="right">
          <el-button
            type="primary"
            style="margin-left: 16px"
            icon="el-icon-plus"
            @click="showForm(0, 'add')"
            v-hasPermi="['客户管理', '新增']"
            >新增</el-button
          >
          <el-button
            type="primary"
            style="margin-left: 16px"
            @click="importExcel()"
            v-hasPermi="['客户管理', '导出']"
            :loading="btnLoading"
            >导出</el-button
          >
          <!--    <el-button
                  type="danger"
                  style="margin-left: 16px"
                  :disabled="multipleSelection.length === 0"
                  @click="deleteSelection()"
                  v-hasPermi="['用户反馈', '删除']"
                  >删除</el-button
                > -->
        </div>
      </div>
      <el-table
        stripe
        :data="table.data"
        v-loading="loading"
        :height="table.height"
        :header-cell-style="{ background: '#eaeef6' }"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column
          prop="orderNo"
          width="200"
          label="订单编号"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="mobile" width="300" label="用户" align="center">
        </el-table-column>
        <el-table-column
          prop="frameNum"
          width="300"
          label="车辆"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="buyDetail" label="订购内容" align="center">
        </el-table-column>
        <el-table-column prop="amount" label="金额（元）" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="下单时间" align="center">
        </el-table-column>
        <el-table-column prop="status" label="支付状态" align="center">
          <template slot-scope="scope">
            <span
              style="color: rgb(255, 153, 0);"
              v-if="scope.row.status === 1"
            >
              待支付
            </span>
            <span
              style="color: rgb(67, 202, 154);"
              v-if="scope.row.status === 2"
            >
              支付成功
            </span>
            <span
              style="color: rgb(245, 108, 108);"
              v-if="scope.row.status === 3"
            >
              支付失败
            </span>
            <span style="color: #333;" v-if="scope.row.status === 4">
              支付关闭
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          :current-page.sync="table.page"
          :page-size="table.pageSize"
          :total="table.total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
    <FormInfo
      ref="formInfoRef"
      :type="formType"
      :id="id"
      :visible="formDialogVisible"
      @visible-change="modalVisibleChange"
      @success="refresh()"
    ></FormInfo>
  </div>
</template>

<script>
import { getOrderList, exportExcel } from '@/api/order';
import FormInfo from './add';
import dayjs from 'dayjs';

export default {
  components: {
    FormInfo,
  },
  data() {
    return {
      id: null,
      formType: '',
      formDialogVisible: false,
      currentNodeKey: 0, //当前选中的点
      loading: false,
      btnLoading: false,
      table: {
        data: [],
        height: 100,
        page: 1,
        pageSize: 50,
        total: 0,
      },
      multipleSelection: [],
      searchInfo: {
        orderNo: '',
        mobile: '',
        frameNum: '',
        startTime: null,
        endTime: null,
      },
      unitArray: [
        {
          key: 1,
          value: '日',
        },
        {
          key: 2,
          value: '月',
        },
        {
          key: 3,
          value: '年',
        },
      ],
      selectTime: [],
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    this.$nextTick(() => {
      this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170;
      window.onresize = () => {
        this.table.height =
          window.innerHeight - this.$refs.table.offsetTop - 170;
      };
    });
  },
  methods: {
    modalVisibleChange(val) {
      this.formDialogVisible = val;
    },
    // 弹窗
    showForm(id, type) {
      this.formDialogVisible = true;
      this.formType = type;
      this.id = id;
    },
    //  导出
    importExcel() {
      this.btnLoadin = true;
      if (this.selectTime && this.selectTime.length > 0) {
        this.searchInfo.startTime = this.selectTime[0] || null;
        this.searchInfo.endTime = this.selectTime[1] || null;
      } else {
        this.searchInfo.startTime = null;
        this.searchInfo.endTime = null;
      }
      const params = {
        ...this.searchInfo,
        page: this.table.page,
        pageSize: this.table.pageSize,
      };
      exportExcel(params)
        .then((res) => {
          this.btnLoading = false;
          const link = document.createElement('a');
          // 创建Blob对象, 固定写法
          let blob = new Blob([res]);
          // 设置元素样式不可⻅
          link.style.display = 'none';
          // 创建下载链接
          link.href = URL.createObjectURL(blob);
          // 获取⽂件名(后端应确保正确返回⽂件名)
          const nowDate = dayjs().format('YYYYMMDDHHmmss');
          const fileName = `${nowDate}订单导出.xlsx`;
          link.setAttribute('download', fileName);
          // 加⼊dom树
          document.body.appendChild(link);
          // ⼿动触发点击事件
          link.click();
          // 移除之前创建的元素
          document.body.removeChild(link);
          // 释放Blob对象
          window.URL.revokeObjectURL(link.href);
        })
        .catch(() => {
          this.btnLoading = false;
        });
    },

    changeTime(dateTime) {
      const currentTime = dateTime;
      const reg = new RegExp('-', 'g'); //去掉时间里面的-
      const a = currentTime.replace(reg, '');
      const regs = new RegExp(' ', 'g'); //去掉时间里面的空格
      const b = a.replace(regs, '');
      const regss = new RegExp(':', 'g'); //去掉时间里面的:冒号
      const c = b.replace(regss, '');
      return c;
    },

    getData() {
      if (this.selectTime && this.selectTime.length > 0) {
        this.searchInfo.startTime = this.selectTime[0] || null;
        this.searchInfo.endTime = this.selectTime[1] || null;
      } else {
        this.searchInfo.startTime = null;
        this.searchInfo.endTime = null;
      }
      const params = {
        ...this.searchInfo,
        page: this.table.page,
        pageSize: this.table.pageSize,
      };
      getOrderList(params).then((da) => {
        da.data.content.forEach((element) => {
          const buyDetailArray = element.detail.map((it) => {
            let unit = this.unitArray.find((item) => item.key === it.unit)
              .value;
            return it.serviceTypeName + ' ' + it.num + unit + ';';
          });
          element.buyDetail = buyDetailArray.join('');
        });

        this.table.data = da.data.content;
        this.table.total = da.data.total;
      });
    },
    toggleSelection() {
      // this.table.data.forEach(row => {
      if (this.multipleSelection.length === this.table.total) {
        return;
      } else {
        this.$refs.multipleTable.toggleAllSelection();
        this.multipleSelection = this.table;
      }
      // });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    search() {
      this.table.page = 1;
      this.getData();
    },
    currentChange() {
      this.getData();
    },
    handleSizeChange(e) {
      this.table.page = 1;
      this.table.pageSize = e;
      this.getData();
    },
    deleteClick() {
      // MessageBox.confirm('此操作将删除该信息, 是否继续?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning',
      // }).then(() => {
      //   deleteAppUser(id).then((res) => {
      //     if (res.code == 0) {
      //       this.$message.success('删除成功!');
      //       this.refresh();
      //     }
      //   });
      // });
    },

    // deleteSelection() {
    //   MessageBox.confirm('确认删除?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning',
    //   }).then(() => {
    //     let params = [];
    //     this.multipleSelection.map((item) => {
    //       params.push(item.id);
    //     });
    //     delFeedBack({ ids: params.join(',') }).then((res) => {
    //       if (res.code == 0) {
    //         this.$message.success('删除成功!');
    //         this.refresh();
    //       }
    //     });
    //   });
    // },
    refresh() {
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.feedback-container {
  display: flex;
  //   flex-direction: column;
  justify-content: space-between;
  //   width: 100%;
  //   height: 100%;
  gap: 0 32px;
  margin: 20px;
  background: #fff;
  box-shadow: 0 0 6px 1px #acacac;

  .content {
    flex: 1;
    min-height: 0;
    border-left: 1px solid #f1f1f1;
    padding: 20px;

    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
        input {
        }
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;
        & + .btn {
          margin-left: 24px;
        }
      }
    }
    .status-icon {
      position: relative;
      top: 2px;
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 100%;
      background: #ff4200;
      &.green {
        background: #00ff00;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
<style lang="less">
.feedback-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
</style>
